import { Controller } from "@hotwired/stimulus"

// Scroll reveal animation controller using Intersection Observer
// Usage: data-controller="scroll-reveal" data-scroll-reveal-animation-value="fade-up"
// Available animations: fade-up, fade-down, fade-left, fade-right, zoom-in, zoom-out, flip-up
export default class extends Controller {
  static values = {
    animation: { type: String, default: "fade-up" },
    delay: { type: Number, default: 0 },
    duration: { type: Number, default: 600 },
    threshold: { type: Number, default: 0.1 },
    once: { type: Boolean, default: true },
    stagger: { type: Number, default: 0 }
  }

  connect() {
    this.setupInitialState()
    this.createObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupInitialState() {
    this.element.style.opacity = "0"
    this.element.style.transition = `all ${this.durationValue}ms cubic-bezier(0.4, 0, 0.2, 1) ${this.delayValue}ms`

    // Set initial transform based on animation type
    switch (this.animationValue) {
      case "fade-up":
        this.element.style.transform = "translateY(40px)"
        break
      case "fade-down":
        this.element.style.transform = "translateY(-40px)"
        break
      case "fade-left":
        this.element.style.transform = "translateX(40px)"
        break
      case "fade-right":
        this.element.style.transform = "translateX(-40px)"
        break
      case "zoom-in":
        this.element.style.transform = "scale(0.9)"
        break
      case "zoom-out":
        this.element.style.transform = "scale(1.1)"
        break
      case "flip-up":
        this.element.style.transform = "perspective(1000px) rotateX(10deg)"
        break
      default:
        this.element.style.transform = "translateY(40px)"
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.reveal()
            if (this.onceValue) {
              this.observer.unobserve(entry.target)
            }
          } else if (!this.onceValue) {
            this.hide()
          }
        })
      },
      {
        threshold: this.thresholdValue,
        rootMargin: "0px 0px -50px 0px"
      }
    )

    this.observer.observe(this.element)
  }

  reveal() {
    this.element.style.opacity = "1"
    this.element.style.transform = "translateY(0) translateX(0) scale(1) rotateX(0)"
  }

  hide() {
    this.setupInitialState()
  }
}
